<span #container
    [ngClass]="{'p-autocomplete p-component':true,'p-autocomplete-dd':dropdown,'p-autocomplete-multiple':multiple}"
    [ngStyle]="style" [class]="styleClass"
>

     <!-- We need to input either an ariaLabel or ariaLabelledBy for this component to be accessible, as we are not using a native label here. -->

    <input #in
        [attr.type]="type"
        [attr.id]="inputId"
        [ngStyle]="inputStyle"
        [class]="inputStyleClass"
        [autocomplete]="autocomplete"
        [attr.required]="required"
        [attr.name]="name"
        [ngClass]="{
            'p-autocomplete-dd-input': dropdown,
            'p-disabled': disabled,
            'p-autocomplete-inputWithIcon p-autocomplete-input p-inputtext p-component': true
        }"
        [value]="inputFieldValue"
        aria-autocomplete="list"
        [attr.aria-controls]="listId"
        [attr.aria-expanded]="overlayVisible"
        aria-haspopup="true"
        [attr.placeholder]="placeholder"
        [attr.size]="size"
        [attr.maxlength]="maxlength"
        [attr.tabindex]="tabindex"
        [readonly]="readonly"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledBy"
        [attr.aria-required]="required"
        [(ngModel)]="inputString"
        (click)="onInputClick($event)"
        (input)="onInput($event)"
        (keydown)="onKeydown($event)"
        (keyup)="onKeyup($event)"
        (focus)="onInputFocus($event)"
        (blur)="onInputBlur($event)"
        (change)="onInputChange($event)"
        (paste)="onInputPaste($event)"
        [attr.aria-describedby]="ariaDescribedBy"
    >
    <div
        class="p-autocomplete-inputIcon"
    >
        <span [agprLoading]="loading" [agprInlineLoadingIndicator]="true" [loadingSmallIndicator]="true"></span>
        <span *ngIf="!loading" class="fa-regular fa-duotone fa-magnifying-glass" aria-hidden="true" tabindex="-1"></span>
    </div>

    <button #ddBtn type="button" pButton
        [icon]="dropdownIcon" class="p-autocomplete-dropdown" [disabled]="disabled" pRipple
        (click)="handleDropdownClick($event)" *ngIf="dropdown" [attr.tabindex]="tabindex"
    ></button>

    <div
        *ngIf="overlayVisible"
        #panel
        [ngClass]="['agpr-prime-override-autocomplete-panel p-autocomplete-panel p-component']"
        [style.min-width]="'500px'"
        [@overlayAnimation]="{value: 'visible', params: {showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions}}"
        (@overlayAnimation.start)="onOverlayAnimationStart($event)"
    >
        <!-- eslint-disable @angular-eslint/template/role-has-required-aria -->
        <ul
            #list
            role="listbox"
            class="p-autocomplete-items"
            [attr.ariaLabel]="resultListAriaLabel | localize"
        >
            <ng-container
                *ngTemplateOutlet="overlayTemplate; context: { suggestions: suggestions, this: this, getOptionGroupChildren: getOptionGroupChildren }">
            </ng-container>
            <ng-container>
                <ng-template ngFor let-optgroup [ngForOf]="suggestions" let-groupIdx="index">
                    <li class="group" role="option">
                        <ng-container *ngTemplateOutlet="
                            groupTemplate;
                            context: {
                                $implicit: optgroup,
                                groupIdx: groupIdx,
                                triggerViewAllInGroup: triggerViewAllInGroup
                            }"
                        ></ng-container>
                    </li>
                    <ng-container *ngTemplateOutlet="
                        itemsListTemplate;
                        context: {
                            $implicit: getOptionGroupChildren(optgroup),
                            selectItem: selectItem,
                            noResults: noResults,
                            group: optgroup,
                            groupIdx: groupIdx,
                            triggerResearchRequest: triggerResearchRequest
                        }"
                    ></ng-container>
                </ng-template>
            </ng-container>
            <li *ngIf="!!footerTemplate" class="footer" role="option">
                <ng-container *ngTemplateOutlet="footerTemplate; context: { $implicit: inputString }"></ng-container>
            </li>
        </ul>
        <!-- eslint-enable @angular-eslint/template/role-has-required-aria -->
    </div>
</span>
